import 'theme/moydom/less/pages/auth.less';

import { createApp } from 'vue';
import LoginPage from './pages/index.vue';

const app = createApp(LoginPage);

app.mount('#app-auth');
